(() => {
  function saleState(now, start, end, ready) {
    if (now < start) return 'before';
    if (now >= end) return 'ended';
    return ready ? 'active' : 'unavailable';
  }
  function init(root) {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const copy = JSON.parse(root.querySelector('[data-bf-copy]').textContent);
    const isB2b = root.dataset.isB2b === 'true';
    const ready = root.dataset.discountReady === 'true';
    const start = Date.parse(root.dataset.start);
    const end = Date.parse(root.dataset.end);
    const cards = [...root.querySelectorAll('[data-bf-product]')];
    const filters = [...root.querySelectorAll('[data-bf-filter]')];
    const search = root.querySelector('[data-bf-search]');
    const count = root.querySelector('[data-bf-results]');
    let chosen = 'all';
    const filter = () => {
      const needle = search.value.toLocaleLowerCase().trim();
      let visible = 0;
      cards.forEach(card => {
        const kindMatches = chosen === 'all' || (chosen === 'vegan' ? card.dataset.vegan === 'true' : card.dataset.kind === chosen);
        card.hidden = !kindMatches || !card.dataset.name.toLocaleLowerCase().includes(needle);
        if (!card.hidden) visible++;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bfFilter === chosen)));
      count.textContent = visible + ' ' + root.dataset.count;
      root.querySelector('[data-bf-empty]').hidden = visible > 0;
    };
    filters.forEach(button => button.addEventListener('click', () => { chosen = button.dataset.bfFilter; filter(); }));
    root.querySelectorAll('[data-bf-preset]').forEach(link => link.addEventListener('click', () => { chosen = link.dataset.bfPreset; search.value = ''; filter(); }));
    search.addEventListener('input', filter);
    filter();
    root.querySelector('[data-bf-tools]').hidden = false;
    const salePrice = card => {
      const option = card.querySelector('[data-bf-variant]')?.selectedOptions[0];
      if (!option) return;
      const sale = card.querySelector('[data-bf-sale]');
      if (sale) sale.textContent = option.dataset.sale;
      card.querySelector('[data-bf-regular]').textContent = option.dataset.regular;
    };
    let state = '';
    const update = () => {
      const now = Date.now();
      const next = saleState(now, start, end, ready);
      if (next !== state) {
        state = next;
        root.dataset.saleState = state;
        root.querySelectorAll('.bf-ticker span').forEach(el => { el.textContent = (copy.ticker[state] || copy.ticker.text) + '  ✦'; });
        const displayState = isB2b ? 'business' : state;
        root.querySelector('[data-bf-state]').textContent = copy.states[displayState];
        root.querySelector('[data-bf-state-message]').textContent = copy.messages[displayState];
        root.querySelector('[data-bf-shopping-notice]').textContent = copy.messages[displayState];
        root.querySelector('[data-bf-clock-block]').hidden = ['ended', 'unavailable'].includes(state) || isB2b;
        root.querySelector('[data-bf-countdown-label]').textContent = state === 'active' ? copy.timer.ends : copy.timer.starts;
        root.querySelector('[data-bf-ended-art]').hidden = state !== 'ended';
        root.querySelectorAll('[data-bf-offer]').forEach(el => { el.hidden = state === 'ended' || state === 'unavailable' || (isB2b && !el.classList.contains('bf-offer-type')); });
        cards.forEach(card => {
          card.querySelector('[data-bf-regular]').hidden = !isB2b && (state === 'before' || state === 'active');
          card.querySelector('[data-bf-price-note]').textContent = isB2b ? root.dataset.businessPrice : state === 'before' ? root.dataset.previewPrice : state === 'active' ? root.dataset.salePrice : root.dataset.currentPrice;
          const add = card.querySelector('[data-bf-add]');
          if (!add.disabled) add.textContent = state === 'active' && !isB2b ? root.dataset.addSale : root.dataset.add;
          salePrice(card);
        });
      }
      const seconds = Math.max(0, Math.ceil(((state === 'before' ? start : end) - now) / 1000));
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds % 86400 / 3600), minutes: Math.floor(seconds % 3600 / 60), seconds: seconds % 60 };
      Object.entries(values).forEach(([key, value]) => { root.querySelector('[data-bf-' + key + ']').textContent = String(value).padStart(2, '0'); });
    };
    update();
    const clock = setInterval(update, 1000);
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) clearInterval(clock); });
    root.querySelectorAll('.bf-product-form').forEach(form => {
      const card = form.closest('[data-bf-product]');
      const variant = form.querySelector('[data-bf-variant]');
      const add = form.querySelector('[data-bf-add]');
      const initialUnavailable = add.disabled;
      if (variant) variant.addEventListener('change', () => {
        salePrice(card);
        add.disabled = variant.selectedOptions[0].dataset.available !== 'true';
        add.textContent = add.disabled ? root.dataset.soldOut : state === 'active' && !isB2b ? root.dataset.addSale : root.dataset.add;
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (add.disabled || !form.reportValidity()) return;
        const status = form.querySelector('[data-bf-status]');
        add.disabled = true;
        add.textContent = root.dataset.adding;
        status.textContent = '';
        status.classList.remove('bf-error');
        try {
          const response = await fetch(root.dataset.addUrl, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const line = await response.json();
          if (!response.ok) throw new Error(line.description || root.dataset.error);
          if (typeof window.refreshCart === 'function') window.refreshCart();
          status.textContent = root.dataset.added;
          const basket = root.querySelector('[data-bf-basket]');
          basket.hidden = false;
          basket.querySelector('[data-bf-basket-status]').textContent = root.dataset.added;
          try {
            const cartResponse = await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              basket.querySelector('[data-bf-cart-count]').textContent = cart.item_count;
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            }
          } catch (_) {}
        } catch (error) {
          status.classList.add('bf-error');
          status.textContent = error.message || root.dataset.error;
        } finally {
          add.disabled = variant ? variant.selectedOptions[0].dataset.available !== 'true' : initialUnavailable;
          add.textContent = add.disabled ? root.dataset.soldOut : state === 'active' && !isB2b ? root.dataset.addSale : root.dataset.add;
        }
      });
    });
  }
  document.querySelectorAll('[data-bf-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bf-root]').forEach(init));
})();
